import React from 'react';
import './Hobbies.css';

export default function Hobbies({ items = [], maxItems = 3 }){
  const visible = items.slice(0, maxItems);
  return (
    <section className="hobbies-grid" aria-label="Hobbies">
      {visible.map(h => (
        <article key={h.id} className="hobby-card" tabIndex={0}>
          <div className="hobby-icon" aria-hidden="true">{h.icon || '⭐'}</div>
          <h4 className="hobby-title">{h.title}</h4>
          <p className="hobby-short">{h.short}</p>
          {h.long ? <details className="hobby-more"><summary>More</summary><div>{h.long}</div></details> : null}
        </article>
      ))}
      {items.length > maxItems ? (
        <div className="hobby-more-link"><a href="/hobbies">View all hobbies</a></div>
      ) : null}
    </section>
  )
}
